// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
(function(){
  Certifications.Modals.CertifierWelcome = createReactClass({

    propTypes: {
      onXOut: PropTypes.func
    },

    closeCallback: function() {
      if(this.props.onXOut) {
        this.props.onXOut();
      }
    },

    render: function() {
      return (
        <div className="DesignSystem media_v2" style={{width: 700}}>
          <div
            className="u-bgColorGrayLighter media-left media-middle u-taCenter u-pr0x"
            style={{width: 268, height: '100%', borderRadius:"6px 0 0 6px"}}
          >
            <img
              src={$image_url("certifications/papers_with_ribbon.png")}
              width="135px"
              alt="Recommendation Icon"
              title="Recommendation Icon"
            />
          </div>
          <div
            className="u-ph7x u-pv15x media-body media-middle"
            style={{width: 432}}
          >
            {this.props.children}
          </div>
          <button
            className="u-fs24 u-tcGray u-positionAbsolute u-mr2x u-mt3x"
            style={{
              top: 0,
              right: 0,
              background: "none",
              border: "none",
              lineHeight: "14px"
            }}
            onClick={this.closeCallback}
            data-dismiss="modal">
            &times;
          </button>
        </div>
      );
    },

  });
})();
